import styled from 'styled-components';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { DoubleArrow } from 'ui/icons/navigation/DoubleArrow';
import { DownArrow } from 'ui/icons/navigation/DownArrow';
import { UpArrow } from 'ui/icons/navigation/UpArrow';
import { HeaderGridRow } from 'ui/indexPages/tables/grid';
import { button, colors, spacing } from 'ui/theme';
import { Alignment, TableHeaderProps } from 'modules/roles/types';

const { ASCENDING, DESCENDING } = SORT_DIRECTIONS;

const StyledHeaderGridRow = styled(HeaderGridRow)`
  padding-right: ${spacing.base};
  padding-left: ${spacing.base};
  border: none;
  border-bottom: ${spacing.single} solid ${colors.grey15};
  border-radius: ${spacing.half} ${spacing.half} 0 0;
`;

export const StyledButton = styled.button<{
  alignment: Alignment;
  isActiveSortColumn: boolean;
  isSortable: boolean;
}>`
  ${button}
  display: flex;
  align-items: center;
  justify-content: ${({ alignment }) => alignment};
  gap: ${spacing.quarter};
  width: 100%;
  padding: ${spacing.half} 0;
  color: ${({ isActiveSortColumn }) =>
    isActiveSortColumn ? colors.purple100 : colors.textPrimary};
  text-align: left;
  cursor: ${({ isSortable }) => (isSortable ? 'pointer' : 'default')};
  outline: none;
  pointer-events: ${({ isSortable }) => (isSortable ? 'auto' : 'none')};
  background: none;
  border: none;
`;

export const TableHeader = ({
  columns,
  gridLayout,
  sortBy,
  sortDirection,
  onSortByChange,
  onSortDirectionChange,
}: TableHeaderProps) => {
  const isAscending = sortDirection === ASCENDING;
  return (
    <StyledHeaderGridRow gridLayout={gridLayout}>
      {columns.map((column) => {
        const { alignment = Alignment.FLEX_START, id, label, isSortable = false } = column;
        const isActiveSortColumn = id === sortBy;
        const handleClick = () => {
          if (isActiveSortColumn) {
            onSortDirectionChange(isAscending ? DESCENDING : ASCENDING);
          } else {
            onSortByChange(id);
            onSortDirectionChange(DESCENDING);
          }
        };
        return (
          <StyledButton
            alignment={alignment}
            data-test={`column-header-${id}`}
            isActiveSortColumn={isActiveSortColumn}
            isSortable={isSortable}
            key={id}
            onClick={() => isSortable && handleClick()}
          >
            <span>{label}</span>
            {isSortable && !isActiveSortColumn && <DoubleArrow isColorInherited={true} />}
            {isSortable && isActiveSortColumn && isAscending && <UpArrow isColorInherited={true} />}
            {isSortable && isActiveSortColumn && !isAscending && (
              <DownArrow isColorInherited={true} />
            )}
          </StyledButton>
        );
      })}
    </StyledHeaderGridRow>
  );
};
